import styled from "styled-components";

export const BgContainer = styled.div`
  background:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.69) 0%,
      /* top: 80% black */ rgba(0, 0, 0, 0.96) 40%,
      /* middle: 70% black */ rgba(0, 0, 0, 1) 80% /* bottom: 100% black */
    ),
    url(${({ $bgImage }) => $bgImage});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: contain;
  min-height: 125vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  min-height: 100vh;
`;

export const Wrapper = styled.div`
  width: 95vw;
  /* min-height: 994px; */
  max-width: 680px;
  // border: 1px solid var(--button-bg);
  /*
  background-color: ${(props) =>
    props.theme === "light" ? "var(--off-white)" : "#141e29"};
  */
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  text-align: center;
  // font-family: "Noto Sans";
  font-family: "Poppins", sans-serif;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
`;

export const Header = styled.div`
  width: 100%;
  padding-top: 1rem;
`;

export const PackagesContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1.3rem;

  @media (max-width: 575.99px) {
    gap: 8px;
  }
`;

export const SinglePackage = styled.div`
  // same divs modified for specific class based
  &.only-packages {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &.only-methods {
    .no-payment-found {
      padding: 1rem 0;
      color: #aaa;
      font-size: 14px;
    }
    .heading {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;

      .title {
        margin-bottom: 0;
      }
    }
    .auto-renewal {
      font-size: 0.9rem;
    }
    .switch {
      position: relative;
      display: inline-block;
      width: 36px;
      height: 18px;
      margin-left: 0.5rem;
    }

    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      transition: 0.3s;
      border-radius: 18px;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 10px; /* 18px height - 4px padding */
      width: 10px; /* same as height */
      left: 4px;
      bottom: 4px;
      background-color: white;
      transition: 0.3s;
      border-radius: 50%;
    }

    input:checked + .slider {
      background-color: var(--button-bg);
    }

    input:checked + .slider:before {
      transform: translateX(
        18px
      ); /* 36px width - knob size (14) - 4px padding */
    }
  }
  &.only-payment-summary {
    background: #191818;
  }

  &.only-payment-summary.desktop {
    display: block;
  }

  &.only-payment-summary.mobile {
    display: none;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    border-radius: 0;
    padding: 0;
    background: none;

    .transition-wrapper {
      transition-property: transform;
      transition-duration: 500ms;
      transition-timing-function: ease-out;
      transform: translateY(0);
    }

    .bg-gradient {
      height: 1.25rem;
      background-image: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.7),
        transparent
      );
    }

    .contents {
      padding-top: 21px;
      padding-bottom: 21px;
      padding-left: 18px;
      padding-right: 20px;
      background: #191818;
    }
  }
  // same div modification ends

  background: ${(props) => (props.active ? "#131313" : "#212121")};
  border: ${(props) =>
    props.active ? "2px solid var(--button-bg)" : "2px solid #e6e6e657"};

  border-radius: 10px;
  width: 80%;
  padding: 1rem 2rem 1.5rem;

  .title {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 1rem;
  }
  .divider {
    background: #e6e6e657;
    width: 100%;
    height: 1px;
  }

  .right {
    text-align: right;
    align-self: flex-end;
  }
  .original-price {
    margin-right: 0.5rem;
    font-size: 0.9rem;
    color: #d4d4d4;
  }
  .sale-price {
    font-size: 1.15rem;
    font-weight: 500;
    color: #fff;
  }

  .all-methods {
    margin-top: 1rem;
  }

  .all-summaries {
    padding: 1.5rem 1.5rem 0rem;
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .total {
      color: #d4d4d4;
      font-weight: 400;
      margin-bottom: 0.7rem;
    }
    .total-payable {
      font-weight: 600;
    }
  }

  .pay-btn {
    cursor: pointer;
    background-color: var(--button-bg);
    color: #fff;
    font-size: 0.8rem;
    padding: 0.5rem 1rem;
    margin-top: 1rem;
    margin-bottom: 0.4rem;
    border-radius: 10px;
    font-weight: 600;
  }
  .pay-btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 575.99px) {
    padding-top: 21px;
    padding-bottom: 21px;
    padding-left: 18px;
    padding-right: 20px;

    // same div modification for mobile starts
    &.only-packages {
      .left {
        flex-basis: 68%;
      }
    }
    &.only-methods {
      margin-bottom: 12.5rem;
      border: 1px solid #5e5e5e;
    }

    &.only-payment-summary.mobile {
      display: block;
      border: none;
    }

    &.only-payment-summary.desktop {
      display: none;
    }
    // same div modification ends

    .title {
      font-size: 16px;
    }
    .right .currency {
      display: flex;
      flex-direction: column;

      .original-price {
        margin-right: 0;
      }
    }
  }
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;
export const List = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  color: #fff;
  @media (max-width: 500px) {
    gap: 0.5rem;
  }
  svg {
    font-size: 10px;
    font-weight: 300;
    @media (max-width: 500px) {
      font-size: 8px;
    }
  }
  span {
    font-size: 12px;
    font-weight: 400;
    @media (max-width: 500px) {
      text-align: left;
    }
  }
`;
export const ActivePayment = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  cursor: pointer;
  width: 90vw;
  max-width: ${(props) => (props.$isCoupon ? "100%" : "245px")};
  // height: 70px;

  &:not(:last-child) {
    margin-bottom: 0.9rem;
  }

  .radio-input-div {
    flex-basis: 7%;
    margin-right: 10%;
    align-self: center;
  }

  .custom-radio {
    appearance: none;
    width: 16px;
    height: 16px;
    border: 1.5px solid #fff;
    border-radius: 50%;
    cursor: pointer;
    display: inline-block;
    position: relative;
  }

  .custom-radio:checked {
    border-color: #fff;
    background-color: transparent;
  }

  .custom-radio:checked::after {
    content: "";
    width: 8px;
    height: 8px;
    background: var(--button-bg);
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  // label {
  //   flex-basis: 83%;
  // }

  .wrap {
    cursor: pointer;
  }

  img {
    height: 32px;
    // max-width: 70px;
  }

  @media (max-width: 575.99px) {
    &:not(:last-child) {
      margin-bottom: 0.5rem;
    }
    .radio-input-div {
      margin-right: 7%;
    }
    img {
      height: 30px;
    }
  }
`;
